export const RENDERED = 'rendered';
export const SUCCESS = 'success';
export const PROCESSING = 'processing';
export const DECLINED = 'declined';
export const PRELOAD = 'preload';

const none = () => {};
export default none;
